import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `
app-report-identified-violations-section {
  display: block;
  width: 100%;
}

/*
 * Scoped Optimus accordion header tokens: the custom properties cascade into the accordion subtree,
 * so the header picks up this section's colours through its own token contract instead of
 * property-level overrides. Prime rounds the first/last panel corners with dedicated tokens,
 * so those are set alongside the base radius.
 */
app-report-identified-violations-section app-accordion-section {
  --p-accordion-header-background: ${dt('inspectionReportViolationsSection.accordionHeader.background')};
  --p-accordion-header-hover-background: ${dt('inspectionReportViolationsSection.accordionHeader.background')};
  --p-accordion-header-active-background: ${dt('inspectionReportViolationsSection.accordionHeader.background')};
  --p-accordion-header-active-hover-background: ${dt('inspectionReportViolationsSection.accordionHeader.background')};
  --p-accordion-header-border-radius: ${dt('inspectionReportViolationsSection.accordionHeader.borderRadius')};
  --p-accordion-header-first-top-border-radius: ${dt('inspectionReportViolationsSection.accordionHeader.borderRadius')};
  --p-accordion-header-last-bottom-border-radius: ${dt(
		'inspectionReportViolationsSection.accordionHeader.borderRadius'
	)};
  --p-accordion-header-last-active-bottom-border-radius: ${dt(
		'inspectionReportViolationsSection.accordionHeader.borderRadius'
	)};
}

app-report-identified-violations-section .report-identified-violations-section {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: ${dt('inspectionReportViolationsSection.content.padding')};
  background: ${dt('inspectionReportViolationsSection.content.background')};
  border-radius: ${dt('inspectionReportViolationsSection.content.borderRadius')};
}

app-report-identified-violations-section .report-identified-violation-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${dt('inspectionReportViolationsSection.row.gap')};
  padding: ${dt('inspectionReportViolationsSection.row.paddingY')} 0;
  border-bottom: 1px solid ${dt('inspectionReportViolationsSection.row.borderColor')};
}

app-report-identified-violations-section .report-identified-violation-row:last-of-type {
  border-bottom: 0;
}

app-report-identified-violations-section .report-identified-violation-row__label {
  display: flex;
  align-items: center;
  gap: ${dt('inspectionReportViolationsSection.row.gap')};
  flex: 1;
  min-width: 0;
}

app-report-identified-violations-section .report-identified-violation-row__index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  padding: 0 12px;
  border-radius: ${dt('inspectionReportViolationsSection.content.borderRadius')};
  background: ${dt('inspectionReportViolationsSection.row.indexBackground')};
  color: ${dt('inspectionReportViolationsSection.row.indexColor')};
  font-size: ${dt('inspectionReportViolationsSection.row.indexFontSize')};
  font-weight: 600;
  line-height: ${dt('inspectionReportViolationsSection.row.indexLineHeight')};
  flex-shrink: 0;
}

app-report-identified-violations-section .report-identified-violation-row__name {
  color: ${dt('inspectionReportViolationsSection.row.nameColor')};
  font-size: ${dt('inspectionReportViolationsSection.row.nameFontSize')};
  line-height: ${dt('inspectionReportViolationsSection.row.nameLineHeight')};
  word-break: break-word;
}

app-report-identified-violations-section .report-identified-violation-row__control {
  flex-shrink: 0;
}
`;
